import React from 'react';
import { IconButton } from 'fronton-react';
import { XCircleIcon } from '@fronton/icons-react';
import { ProductSuggestion, ServiceSuggestion } from 'types/suggestions';
import clsx from 'clsx';
import { searchClear } from './styles';

export interface ClearButtonProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'aria-label'> {
  expanded: boolean;
  value: string;
  selectedItem: NonNullable<ServiceSuggestion | ProductSuggestion> | null;
}

export const ClearButton = (props: ClearButtonProps) => {
  const { expanded, value, selectedItem, ...rest } = props;

  return (
    <IconButton
      {...rest}
      form="headersearchform"
      size="m"
      label="Удалить поисковый запрос"
      data-qa-header-search-clear=""
      data-qa="clear-button"
      withExtraClickZone
      variant="secondary"
      className={clsx(searchClear, { show: expanded && value })}>
      <XCircleIcon type="fill" size="l" color="text-primary" />
    </IconButton>
  );
};
